import { Component, ChangeDetectionStrategy, OnInit, OnDestroy, inject } from '@angular/core';
import { Subscription } from 'rxjs';
import { PopupService } from '@app/shared/popup';
import { ProjectsService } from './services/projects.service';
import { NgClass, AsyncPipe } from '@angular/common';
import { ProjectComponent } from '../../../shared/components/project/project.component';

@Component({
    selector: 'app-projects',
    templateUrl: './projects.component.html',
    styleUrls: ['./projects.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [ProjectsService, PopupService],
    imports: [NgClass, ProjectComponent, AsyncPipe],
})
export class ProjectsComponent implements OnInit, OnDestroy {
    private projectsService = inject(ProjectsService);

    readonly projects$ = this.projectsService.projects$;

    private subscriptions = new Subscription();

    ngOnInit(): void {
        this.projectsService.dispatch();
    }

    ngOnDestroy(): void {
        this.projectsService.destroy();
        this.subscriptions.unsubscribe();
    }
}
